import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  image?: string;
  url: string;
  type?: string;
  structuredData?: object;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords = "healthcare technology, medical equipment, hospital solutions, medical carts, healthcare IT",
  image = "/images/logos/jvp-logo.png",
  url,
  type = "website",
  structuredData
}) => {
  const fullTitle = title.includes('JVP') ? title : `${title} | JVP Health Tech Solutions`;
  const origin = 'https://www.jvphealthtechsolutions.com';
  const fullImage = image.startsWith('http') ? image : `${origin}${image}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta key="description" name="description" content={description} />
      <meta key="keywords" name="keywords" content={keywords} />
      <meta key="author" name="author" content="JVP Health Tech Solutions" />
      <meta key="robots" name="robots" content="index, follow" />
      <link key="canonical" rel="canonical" href={url} />

      <meta key="og:title" property="og:title" content={fullTitle} />
      <meta key="og:description" property="og:description" content={description} />
      {fullImage && <meta key="og:image" property="og:image" content={fullImage} />}
      <meta key="og:url" property="og:url" content={url} />
      <meta key="og:type" property="og:type" content={type} />
      <meta key="og:site_name" property="og:site_name" content="JVP Health Tech Solutions" />

      <meta key="twitter:card" name="twitter:card" content={fullImage ? 'summary_large_image' : 'summary'} />
      <meta key="twitter:title" name="twitter:title" content={fullTitle} />
      <meta key="twitter:description" name="twitter:description" content={description} />
      {fullImage && <meta key="twitter:image" name="twitter:image" content={fullImage} />}

      <meta key="language" name="language" content="English" />

      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;